module.exports = "<ng-table-group-row></ng-table-group-row>\n<ng-table-sorter-row></ng-table-sorter-row>\n<ng-table-filter-row></ng-table-filter-row>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-table/src/browser/header.html
// module id = 2155
// module chunks = 2